import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const TableBody = ({ data, columns }) => {
  const renderContent = (item, column) => {
    if (columns[column].component) {
      const component = columns[column].component;
      if (typeof component === "function") {
        return component(item);
      }
      return component;
    }
    return _.get(item, columns[column].path);
  };
  return (
    <tbody className="overflow-y-scroll">
      {data.map((item) => (
        <tr
          key={item._id}
          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 "
        >
          {Object.keys(columns).map((column) => (
            <td key={column} className="py-4 px-2 md:px-6">
              {renderContent(item, column)}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.object.isRequired,
};

export default TableBody;
